module.exports = __webpack_public_path__ + "img/gift.d5e3599c.png";